import { createRoot } from 'react-dom/client';
import Root from './containers/Root';

const node = document.querySelector('#application');

if (!node) {
  throw new Error('Application root element not found');
}

const root = createRoot(node);

root.render(<Root />);
